import { Editor, Path, Point, Range, ReactEditor, Transforms } from '@lumapps/wrex/slate';
import { Wrex } from '@lumapps/wrex/types';

import { isHeading } from './isHeading';

export const changeHeadingLevel = (
    editor: Editor | ReactEditor,
    level: number,
    at?: Range | Point | Path | null,
): void => {
    const selection = at || editor.selection;
    if (!selection) {
        return;
    }

    // Change heading level of the root blocks.
    Transforms.setNodes(editor, { level } as Partial<Wrex.Element>, {
        match: (node) => !Editor.isEditor(node) && isHeading(node),
        mode: 'highest',
        at: selection,
    });
};
